import React, { useState } from 'react'
import {
  Button,
  ContextMenu,
  makeButtonWithMenu,
  Flex,
  FlexItem,
  IconArrow1Down
} from 'mailup-web-components'

import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'

import { beePluginState, editorState } from '../recoil/state/editor'
import styled from '@emotion/styled'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import { modalSaveNewAndRenameState } from '../recoil/state/modals'
import { pageState } from '../recoil/state/page'
import { checkCountSavedRowsCallback } from '../recoil/callbacks/callbacks'

const SaveRowButton = () => {
  const intl = useIntl()
  const history = useHistory()
  const {
    instance: beePluginInstance,
    loaded: beePluginLoaded
  } = useRecoilValue(beePluginState)
  const { backUrl } = useRecoilValue(pageState)
  const setEditorState = useSetRecoilState(editorState)
  const setModalSaveNewAndRename = useSetRecoilState(modalSaveNewAndRenameState)
  const { title } = useRecoilValue(pageState)
  const checkCountSavedRows = useRecoilCallback(checkCountSavedRowsCallback, [])

  const handleClickBtn = value => {
    switch (value) {
      case 'SAVE-AND-EXIT':
        setEditorState(prev => ({
          ...prev,
          exitAfertSave: true
        }))

        beePluginInstance.save()

        break

      case 'SAVE':
        setEditorState(prev => ({
          ...prev,
          exitAfertSave: false
        }))
        beePluginInstance.save()

        break

      case 'EXIT':
        history.push(backUrl)
        break

      case 'RENAME':
        setModalSaveNewAndRename(prev => ({
          ...prev,
          show: true,
          mode: 'rename',
          name: title
        }))
        break

      case 'SAVENEW':
        checkCountSavedRows().then(res => {
          if (res) {
            setModalSaveNewAndRename(prev => ({
              ...prev,
              show: true,
              mode: 'new'
            }))
          }
        })

        break
    }
  }

  const ButtonComponent = () => (
    <Button
      kind='primary'
      data-mu-test='save-template-menu'
      disabled={!beePluginLoaded}
    >
      <IconArrow1Down />
    </Button>
  )

  const MenuComponent = () => {
    const items = []

    items.push({
      label: intl.formatMessage({ id: 'Load.SaveRow.Save' }),
      value: 'SAVE',
      onClick: handleClickBtn
    })
    items.push({
      label: intl.formatMessage({ id: 'Load.SaveRow.Rename' }),
      value: 'RENAME',
      onClick: handleClickBtn
    })
    items.push({
      label: intl.formatMessage({ id: 'Load.SaveRow.SaveNewRow' }),
      value: 'SAVENEW',
      onClick: handleClickBtn
    })
    items.push({
      label: intl.formatMessage({ id: 'Load.SaveRow.NoSaveExit' }),
      value: 'EXIT',
      onClick: handleClickBtn
    })

    return <ContextMenu items={items} />
  }

  const ButtonWithMenu = makeButtonWithMenu(ButtonComponent, MenuComponent)

  return (
    <Flex columnGap='8px' justifyContent='flex-end'>
      {/* //onClick={() => handleClickBtn('EXIT')} */}
      <StyledSaveMessageContainer>
        <Flex alignItems='center'>
          <Button
            kind='primary'
            data-mu-test='save-template-save'
            onClick={() => handleClickBtn('SAVE-AND-EXIT')}
            disabled={!beePluginLoaded}
          >
            {intl.formatMessage({ id: 'Load.SaveRow.SaveBackToMessage' })}
          </Button>

          <ButtonWithMenu />
        </Flex>
      </StyledSaveMessageContainer>
    </Flex>
  )
}

export default SaveRowButton

const StyledSaveMessageContainer = styled(FlexItem)`
  .e-button:first-of-type {
    border-radius: 4px 0 0 4px;
    &:hover {
      cursor: pointer;
    }
  }

  .c-button-with-menu__button > .e-button {
    border-radius: 0 4px 4px 0;
    margin-left: 1px;
    padding: 0 13px;
  }

  .c-button-with-menu__menu {
    right: -8px;
  }
`
